import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';

function useGtmSearchTracking() {
  useEffect(() => {
    let searchDebounceTimer: number;

    const handleInput = (e: Event) => {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }

      // Only track search-type inputs (semantic HTML5)
      if (e.target.type !== 'search') {
        return;
      }

      const searchValue = e.target.value.trim();

      // Only track if there's actual search text
      if (!searchValue) {
        return;
      }

      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = window.setTimeout(() => {
        const pathname = window.location.pathname;
        const table = pathname.substring(pathname.lastIndexOf('/') + 1) || pathname;

        triggerGoogleTagManagerCustomEvent(GtmEvents.SEARCH_CONDUCTED, {
          length: searchValue.length,
          table,
        });
      }, 1000);
    };

    document.addEventListener('input', handleInput, { capture: true });
    return () => {
      document.removeEventListener('input', handleInput, { capture: true });
      clearTimeout(searchDebounceTimer);
    };
  }, []);
}

export default useGtmSearchTracking;
